import React from 'react';
import { cn } from '../../utils/cn';

const variants = {
  primary: 'bg-primary-600 hover:bg-primary-700 text-white border border-primary-600 hover:border-primary-700',
  secondary: 'bg-secondary-600 hover:bg-secondary-700 text-white border border-secondary-600 hover:border-secondary-700',
  accent: 'bg-accent-600 hover:bg-accent-700 text-white border border-accent-600 hover:border-accent-700',
  outline: 'bg-beige-50 border-2 border-brand-blue text-brand-blue hover:bg-brand-blue hover:text-white hover:border-brand-blue',
  ghost: 'text-neutral-700 hover:text-neutral-900 hover:bg-neutral-50',
  danger: 'bg-red-600 hover:bg-red-700 text-white border border-red-600 hover:border-red-700',
  warning: 'bg-amber-500 hover:bg-amber-600 text-white border border-amber-500 hover:border-amber-600',
  success: 'bg-green-600 hover:bg-green-700 text-white border border-green-600 hover:border-green-700',
};

const sizes = {
  sm: 'px-5 py-2 text-sm tracking-luxury',
  md: 'px-7 py-3 text-base tracking-luxury',
  lg: 'px-9 py-4 text-base tracking-luxury',
  xl: 'px-12 py-5 text-lg tracking-luxury',
};

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  disabled = false,
  loading = false,
  icon: Icon = null,
  iconPosition = 'left',
  fullWidth = false,
  onClick,
  type = 'button',
  ...props
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={cn(
        'inline-flex items-center justify-center gap-2 font-medium',
        'transition-all duration-200 ease-out',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-600 focus-visible:ring-offset-2',
        'active:scale-[0.98]',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        'uppercase text-sm',
        'font-button',
        variants[variant],
        sizes[size],
        fullWidth && 'w-full',
        className
      )}
      style={{ borderRadius: 0, ...props.style }}
      {...props}
    >
      {loading && (
        <svg 
          className="animate-spin h-5 w-5" 
          xmlns="http://www.w3.org/2000/svg" 
          fill="none" 
          viewBox="0 0 24 24"
        >
          <circle 
            className="opacity-25" 
            cx="12" 
            cy="12" 
            r="10" 
            stroke="currentColor" 
            strokeWidth="4"
          />
          <path 
            className="opacity-75" 
            fill="currentColor" 
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      )}
      {Icon && iconPosition === 'left' && !loading && <Icon className="h-5 w-5" />}
      {children}
      {Icon && iconPosition === 'right' && !loading && <Icon className="h-5 w-5" />}
    </button>
  );
};

export default Button;

